module.exports = __webpack_public_path__ + "static/media/motor-delivery.8c84f96a.png";